import { Store } from 'vuex';
import { SELECTOR_FILTER_TREE } from "@/App.settings";
import SelectModeEnum from "@/enums/SelectModeEnum";
import FilterTreeStore from "@/store/FilterTreeStore";
import FilterT from "@/types/FilterTree/FilterT";
import IConfigTree from "@/interfaces/IConfigTree";

/** Classe d'instanciation d'un nouveau FilterTree */
export class FilterTreeBuilder {
	/** Instance VueX */
	private store!: Store<any>;

	/** Initialisation 
	 * @param store			  Instance de $store
	 * @param filterTreeName  Nom de la nouvelle instance à créer
	 * @param grouping		  Regroupement à appliquer
	 * @param showLoadingMask Indique si un masque de chargement doit être affiché ou non
	*/
	public constructor(store: Store<any>, filterTreeName: string, grouping: FilterT = undefined, showLoadingMask: boolean = true) {
		this.store = store;
		this.filterTreeName = filterTreeName;
		this.grouping = grouping;
		this.showLoadingMask = showLoadingMask;
	}

	/** Nom de la nouvelle instance à FilterTreeStore */
	private filterTreeName: string = SELECTOR_FILTER_TREE;
	/** Nom de la nouvelle instance à FilterTreeStore */
	public get FilterTreeName() {
		return this.filterTreeName;
	}

	/** Indique le regroupement à appliquer */
	private grouping!: FilterT;

	/** Indique si le message de chargement de l'arborescence doit être affiché ou non */
	private showLoadingMask: boolean = true;
	public get ShowLoadingMask(): boolean {
		return this.showLoadingMask;
	}

	/** Créé une nouvelle instance de FilterTree si elle n'existe pas déjà sinon elle est réinitialisée  */
	private async createInstance(): Promise<void> {
		/** Instanciation du VueX de sélection spécifique */
		if (this.store.hasModule(this.filterTreeName)) {
			await this.store.dispatch(this.filterTreeName + "/Reset", {});
			console.warn("FilterTreeBuilder - createInstance() - Le module VueX '%s' est déjà instancié ! Il a donc été reinitialisé !", this.filterTreeName);
		}
		else 
			this.store.registerModule(this.filterTreeName, FilterTreeStore);

		/** @description HideStoreMediator passé à True dans FilterTreeBuilder.ts car ces instances de FilterTree n'ont pas besoin d'utiliser le StoreMediator pour activer/désactiver le rafraichissement de composants via les stratégies d'arbo */
		await this.store.dispatch(this.filterTreeName + "/SetIsStoreMediatorDisabled", true);
	}

	public async Clone(sourceFilterTree: string = undefined, pins = undefined, configTree: IConfigTree = undefined, selectMode: SelectModeEnum = undefined) {
		await this.createInstance();

		console.debug('FilterTreeBuilder - Clone() - sourceFilterTree : %O - pins : %O - configTree : %O - selectMode : %O', sourceFilterTree, pins, configTree, selectMode);
		
		await this.store.dispatch(this.filterTreeName + "/CloneTree", { selectMode: selectMode, filterTreeStore: sourceFilterTree, pins: pins, grouping: this.grouping, cleanNodes: true, showLoadingMask: this.showLoadingMask, configTree: configTree });

		return await this.store.dispatch("HideLoadingMask", {});
	}

	/** 
	 * Chargement de l'arborescence à partir du server
	 * @param sourceFilterTree	Nom de l'instance de FilterTree à utiliser comme base (uniquement pour clonage sans passer par le server)
	 * @param selectedNodeId	Id de noeud à sélectionner
	 * @param preview			Mode prévisualisation
	 * @param configTree		
	 **/
	public async Load(isUserPerimeter: boolean = true, pins = undefined, selectMode: SelectModeEnum = undefined, configTree: IConfigTree = undefined): Promise<any> {
		await this.createInstance();

		console.debug('FilterTreeBuilder - Load() - LoadData - this.Grouping : %O - pins: %O', this.grouping, pins);
		if (this.grouping) {
			await this.store.dispatch(this.filterTreeName + "/SetGrouping", this.grouping);
			await this.store.dispatch(this.filterTreeName + "/LoadData", { selectMode: selectMode, isUserPerimeter: isUserPerimeter, pins: pins, enableGroup: this.grouping, showLoadingMask: this.showLoadingMask, configTree: configTree });
		}
		else
			await this.store.dispatch(this.filterTreeName + "/LoadData", { selectMode: selectMode, isUserPerimeter: isUserPerimeter, pins: pins, enableGroup: false, showLoadingMask: this.showLoadingMask, configTree: configTree });

		return await this.store.dispatch("HideLoadingMask", {});
	}
	

	/** Déchargement du VueX de sélection spécifique */
	public UnloadFilterTree() {
		console.debug("FilterTreeBuilder - UnloadFilterTree() - déchargement du module VueX : ", this.filterTreeName);

		if (this.store.hasModule(this.filterTreeName)){
			this.store.commit(this.filterTreeName + "/reset");
			this.store.unregisterModule(this.filterTreeName);
			console.debug("FilterTreeBuilder - UnloadFilterTree() - déchargement du module VueX Fin");
		}
	}

	// destroyed () {
	// 	this.unloadFilterTree();
	// }
}